var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBitcoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#FF9F38"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.1198 18.1436C27.4225 16.1529 25.8832 15.0825 23.7802 14.3682L24.4626 11.6708L22.7971 11.2624L22.132 13.8886C21.7035 13.7825 21.264 13.6838 20.8251 13.5852L20.7971 13.5789L21.467 10.9357L19.8015 10.5263L19.1191 13.2228L19.0463 13.2064C18.7089 13.1304 18.3769 13.0556 18.055 12.9758L18.057 12.9673L15.7592 12.4021L15.3158 14.1555C15.3158 14.1555 16.5524 14.4347 16.5264 14.4518C17.2011 14.618 17.3225 15.0578 17.3023 15.4073L16.5254 18.4799C16.5717 18.4913 16.6315 18.5084 16.6989 18.534L16.5225 18.4913L15.4334 22.7957C15.3505 22.9971 15.1414 23.3 14.6691 23.1851C14.6864 23.2089 13.4585 22.8878 13.4585 22.8878L12.6316 24.7665L14.8002 25.2994C15.0331 25.357 15.2634 25.4162 15.4913 25.4749L15.4914 25.4749C15.6577 25.5177 15.8228 25.5601 15.9867 25.6014L15.2975 28.3292L16.962 28.7376L17.6444 26.0402C18.0994 26.1608 18.5408 26.2729 18.9726 26.3793L18.2921 29.0653L19.9576 29.4737L20.6468 26.7516C23.4881 27.2816 25.624 27.0679 26.5232 24.5357C27.248 22.4975 26.4876 21.3207 24.9927 20.5542C26.0818 20.3073 26.9011 19.6016 27.1198 18.1436ZM23.3125 23.4041C22.8412 25.2747 19.8702 24.5014 18.5102 24.1474L18.5101 24.1474C18.3876 24.1155 18.2782 24.087 18.1849 24.0642L19.1005 20.4502C19.2144 20.4783 19.3536 20.5091 19.5113 20.544C20.918 20.8554 23.7969 21.4928 23.3125 23.4041ZM19.7943 18.8666C20.9275 19.1648 23.3984 19.8149 23.8286 18.1149C24.2686 16.3762 21.8665 15.8525 20.6932 15.5968C20.561 15.5679 20.4443 15.5425 20.3491 15.5191L19.5202 18.7959C19.5988 18.8152 19.691 18.8394 19.7943 18.8666Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBitcoin);
export default __webpack_public_path__ + "static/media/bitcoin.35b3ead74ee042086ff71cfd44da7fd2.svg";
export { ForwardRef as ReactComponent };